import { useState } from "react";
import { NotePencil, Trash, PaperPlaneRight } from "@phosphor-icons/react";

const fmtWhen = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-CA", { month: "short", day: "numeric" }) +
    " · " + d.toLocaleTimeString("en-CA", { hour: "numeric", minute: "2-digit" });
};

export const LeadNotes = ({ lead, onAdd, onDelete, busy }) => {
  const [text, setText] = useState("");
  const log = lead.call_log || [];

  const submit = async (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    const ok = await onAdd(lead.id, t);
    if (ok) setText("");
  };

  return (
    <div className="mt-4 pt-4 border-t border-brand-line" data-testid={`notes-${lead.id}`}>
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.16em] text-brand-muted mb-2">
        <NotePencil size={13} weight="duotone" />
        Call log {log.length > 0 && <span className="text-brand-forest">({log.length})</span>}
      </div>

      <form onSubmit={submit} className="flex items-center gap-2">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={2000}
          placeholder="Left voicemail, calling back Thursday…"
          data-testid={`input-note-${lead.id}`}
          className="flex-1 h-10 px-3 rounded-md border border-brand-line bg-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-forest"
        />
        <button
          type="submit"
          disabled={busy || !text.trim()}
          data-testid={`btn-add-note-${lead.id}`}
          className="h-10 px-3 rounded-md bg-brand-forest text-white hover:bg-brand-copper transition-colors disabled:opacity-40 disabled:pointer-events-none"
          aria-label="Add note"
        >
          <PaperPlaneRight size={16} weight="fill" />
        </button>
      </form>

      {log.length > 0 && (
        <ul className="mt-3 space-y-2">
          {log.map((n) => (
            <li
              key={n.id}
              data-testid={`note-${n.id}`}
              className="group flex items-start gap-2 text-xs bg-brand-cream/50 rounded-md px-3 py-2"
            >
              <div className="flex-1">
                <div className="text-brand-ink/85 leading-relaxed whitespace-pre-wrap">{n.text}</div>
                <div className="mt-1 text-[10px] uppercase tracking-wider text-brand-muted">
                  {fmtWhen(n.created_at)}
                </div>
              </div>
              <button
                type="button"
                disabled={busy}
                onClick={() => onDelete(lead.id, n.id)}
                data-testid={`btn-delete-note-${n.id}`}
                className="md:opacity-0 md:group-hover:opacity-100 focus:opacity-100 text-brand-muted hover:text-red-600 transition-all disabled:pointer-events-none"
                aria-label="Delete note"
              >
                <Trash size={13} weight="bold" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
